import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { DataTableSortEnum, DataTableStateModel } from 'app/shared/components/dynamic-table/dynamic-table.model';
import { HelperService } from 'app/shared/services/helper.service';
import { map, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ProblemRecordsFormService {

  public cases: any[] = [];

  resetProblemRecordCasesEmiter: EventEmitter<boolean> = new EventEmitter();

  constructor(private http: HttpClient, private helperService: HelperService) { }

  saveProblemRecords(params: any): Observable<any> {
    let url = this.http.post('/v1/problem-record-management', params);

    if(params.id) {
      url = this.http.put(`/v1/problem-record-management?id=${params.id}`, params);
    }

    return url;
  }

  getProblemRecord(id: number): Observable<any> {
    return this.http.get(`/v1/problem-record-management?id=${id}`);
  }

  // TODO: NEW IMPLEMENTATION
  // getElkProblemRecord(id: number): Observable<any> {
  //   return this.http.get(`/v1/elksearch-problem-record?id=${id}`);
  // }

  saveProblemRecordLinks(problemRecordId: number, params: any): Observable<any> {
    return this.http.put(`/v1/problem-record-links?problemRecordId=${problemRecordId}`, params);
  }

  getCaseRecords(problemRecordId: number, data: DataTableStateModel): Observable<any> {
    data = this.helperService.replaceFilterBlanksSelection(data);

    let params: any = {
      caseOrderField: data.sortingValue.prop,
      skipCount: data.showItemsPerPage * (data.pageNumber - 1),
      takeCount: data.showItemsPerPage,
      isOrderByDescending: data.sortingValue.dir === DataTableSortEnum.SORT_DESC ? true : false
    };

    const url = `/v1/problem-record-cases?problemRecordId=${problemRecordId}&OrderField=${params.caseOrderField}&SkipCount=${params.skipCount}&TakeCount=${params.takeCount}&IsOrderByDescending=${params.isOrderByDescending}`;

    return this.http.get(url);
  }

  getProblemRecordsCaseDropdown(params: any): Observable<any> {
    const url = '/v1/problem-record-cases/search';

    return this.http.post(url, params);
  }

  addOrRemoveProblemRecordsCase(problemRecordId: number, caseId: number, isDelete: boolean): Observable<any> {
    const params = {
      caseId: caseId
    };

    const url = this.http.post(`/v1/problem-record-cases/${isDelete ? 'remove' : 'add'}?problemRecordId=${problemRecordId}`, params);

    return url;
  }

}
